import React from 'react';
import $ from 'jquery'; 

export default class Line extends React.Component {
  constructor(props) {
    super(props);

    this.width = 0;
    this.windowWidth = undefined;
    this.animationFrame = undefined;
    this.time = undefined;

    this.animate = this.animate.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);

    this.state = {
      currentX: 0,
    };
  }

  componentDidMount() {
    this.width = this.refs.el.clientWidth;
    this.windowWidth = $(window).width();
    window.addEventListener('resize', this.handleWindowResize);
    this.animate();
  }

  componentWillUnmount() {
    window.cancelAnimationFrame(this.animationFrame);
    window.removeEventListener('resize', this.handleWindowResize);
  }

  handleWindowResize(e) {
    this.windowWidth = $(window).width();
  }

  animate() {
    const now = new Date().getTime();
    const delta = now - (this.time || now);
    this.time = now;

    const bounds = this.refs.el.getBoundingClientRect();
    const distanceFromLeft = bounds.left + this.width;
    let currentX;

    if (distanceFromLeft > 0) {
      currentX = parseFloat(this.state.currentX - this.props.speed * delta / 16);
    } else {
      currentX = this.state.currentX + (this.width + this.windowWidth);
    }

    this.setState({ currentX });
    this.animationFrame = window.requestAnimationFrame(this.animate);
  }

  render() {
    const { currentX } = this.state;
    const style = currentX === undefined ? {} : {
      transform: `translateX(${currentX}px)`,
    };

    return (
      <div ref="el" className="MovingLines__line" style={style}>
        <div></div>
        <div></div>
      </div>
    );
  }
}
